import React from 'react';
import { Button, MainLayout, Triptych } from '@app/components';
import { VariationCard, VariationCreate, VariationDeleteModal, VariationList, VariationUpdate } from '@app/features/Variation';
import { useResourceScreenHelpers } from '@app/hooks';
import { variationApi } from '@app/store';
import { ProductHeader } from '@app/features';
import { IVariation } from '@app/common';
import { CheckPermissions } from '@app/components/CheckPermissions';

export const VariationScreen = () => {
  const [readOne, { isFetching }] = variationApi.useLazyReadOneVariationQuery();
  const [deleteOne, { isLoading }] = variationApi.useDeleteOneVariationMutation();

  const { triptych, modal, onDelete, onUpdate, mode, selectedItem, item: variation } = useResourceScreenHelpers<IVariation>();

  const openCard = (item: Partial<IVariation>) => {
    onUpdate(readOne({
      filters: { _id: { $eq: item?._id } },
    }), item)
  }

  return (
    <MainLayout
      header={(
        <ProductHeader>
          <CheckPermissions permissions={['dashboard::variations.create']}>
            <Button
              onPress={() => triptych.open({ mode: 'CREATE' })}
              title='Ajouter une variation' />
          </CheckPermissions>
        </ProductHeader>
      )}>

      <VariationDeleteModal
        {...modal}
        onDelete={(variation) => onDelete(deleteOne(variation._id!))}
        isLoading={isLoading} />

      <Triptych
        list={(
          <VariationList
            selectedRowItem={selectedItem}
            onRowPress={(item) => triptych.close({ data: item, mode: 'UPDATE' })}
            onUpdate={openCard}
            onDelete={modal.open} />
        )}
        card={(
          <VariationCard
            variation={variation ?? selectedItem}
            toggle={(mode) => mode === 'UPDATE' ? openCard(selectedItem) : triptych.toggle()} />
        )}
        form={(
          mode === 'CREATE'
            ? <VariationCreate />
            : <VariationUpdate
              variation={variation}
              isFetching={isFetching}
              onDelete={modal.open} />
        )} />
    </MainLayout>
  );
};

